/**
 * Check if a given object implements the CreateUploadUrlResponse interface.
 */
export function instanceOfCreateUploadUrlResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "uploadUrl" in value;
    isInstance = isInstance && "assetId" in value;
    return isInstance;
}
export function CreateUploadUrlResponseFromJSON(json) {
    return CreateUploadUrlResponseFromJSONTyped(json, false);
}
export function CreateUploadUrlResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'uploadUrl': json['uploadUrl'],
        'assetId': json['assetId'],
    };
}
export function CreateUploadUrlResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'uploadUrl': value.uploadUrl,
        'assetId': value.assetId,
    };
}
